/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_chat_message_actions_copymessage1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지 복사`)
};

const en_chat_message_actions_copymessage1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy message`)
};

const ja_chat_message_actions_copymessage1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージをコピー`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const chat_message_actions_copymessage1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.chat_message_actions_copymessage1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("chat_message_actions_copymessage1", locale)
	if (locale === "ko") return ko_chat_message_actions_copymessage1(inputs)
	if (locale === "en") return en_chat_message_actions_copymessage1(inputs)
	return ja_chat_message_actions_copymessage1(inputs)
};
export { chat_message_actions_copymessage1 as "chat_message_actions_copyMessage" }